<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/entities/auth'
import { useLoginDialog } from '@/shared/composables/useLoginDialog'
import { CButton } from '@/shared/ui'

const { openLoginDialog } = useLoginDialog()
const { t } = useI18n()
const router = useRouter()
const authStore = useAuthStore()

function onTryForFree() {
  if (authStore.isAuthenticated) {
    router.push({ name: 'Tariffs' })
    return
  }
  openLoginDialog()
}
</script>

<template>
  <section class="container mx-auto pb-4">
    <div
      data-aos="fade-up"
      data-aos-duration="1200"
      data-aos-delay="400"
      class="cta-bg md:rounded-[20px] rounded-2xl text-center text-white px-4 sm:px-8 py-12 sm:py-16 md:py-20 lg:py-[88px]"
    >
      <div class="max-w-[774px] mx-auto">
        <h2
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-delay="600"
          class="font-medium text-[32px] sm:text-3xl md:text-[56px] leading-10 md:leading-[64px] mb-7"
        >
          {{ t("join_today_title") }}
        </h2>
        <p
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-delay="800"
          class="text-white text-base sm:text-lg leading-6 sm:leading-7 mb-7"
        >
          {{ t("join_today_description") }}
        </p>
        <CButton
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-delay="1000"
          type="default"
          class="!bg-white !text-[#409EFF] !px-8 !py-4 text-lg !rounded-[4px] !leading-6"
          @click="onTryForFree"
        >
          {{ t("try_for_free_button") }}
        </CButton>
      </div>
    </div>
  </section>
</template>

<style scoped>
.cta-bg {
  background: linear-gradient(260deg, #7c1af8 3.61%, #eb3cca 98.57%);
}
</style>
